export abstract class LogoutService {
  abstract logout(): Promise<void>;
}
